import { MakeModelKeywordSearch } from '../../../../features/MakeModelKeywordSearch/MakeModelKeywordSearch';

import { useMotorsSearch } from './MotorSearch.hook';

import { MotorSearchProps } from './MotorSearch.typed';

export const MotorSearch = (props: MotorSearchProps) => {
  const { makes } = props;

  const { onSelectOption } = useMotorsSearch();

  const modalDisplayConfig = {
    small: 'block',
    medium: 'none',
    large: 'none',
  };
  const dropdownDisplayConfig = {
    small: 'none',
    medium: 'block',
    large: 'block',
  };

  return (
    // TODO: Add styles
    <div>
      <MakeModelKeywordSearch
        onSelectOption={onSelectOption}
        modalDisplayConfig={modalDisplayConfig}
        dropdownDisplayConfig={dropdownDisplayConfig}
        makes={makes}
      />
      {/* TODO: Add filters */}
    </div>
  );
};
